const money_format = window.FoxTheme.settings.moneyFormat;
const COLOR_INPUT_SELECTOR = 'input[type="radio"][name*="Color"]:checked';


const applyOverstockPricing = (variantPrice, overstockPrice) => {
 
  const formattedVariantPrice = FoxTheme.Currency.formatMoney(variantPrice, money_format);
  const formattedOverstockPrice = FoxTheme.Currency.formatMoney(overstockPrice, money_format);

    const priceWrapper = document.querySelector('.product__block--price .f-price');
    if (!priceWrapper) return;

    priceWrapper.classList.add('f-price--on-sale');

    const salePrice = priceWrapper.querySelector('.f-price__sale .f-price-item--sale');
    const comparePrice = priceWrapper.querySelector('.f-price__sale .f-price-item--regular');
    const regularPrice = priceWrapper.querySelector('.f-price__regular .f-price-item--regular');

    if (salePrice) {
      salePrice.textContent = formattedOverstockPrice;
    }

    if (comparePrice) {
      comparePrice.innerHTML = `<s>${formattedVariantPrice}</s>`;
    }

    if (regularPrice) {
      regularPrice.textContent = formattedVariantPrice;
    }
};

document.addEventListener('variant:changed', function (evt) {
  const variant = evt.detail?.variant;
  if (!variant) return;

  const container = document.querySelector('.product-form__input--color') || document;
  const checked = container.querySelector(COLOR_INPUT_SELECTOR);
  if (!checked) return;

  const packCount = checked.dataset.packCount || '';
  if (packCount) {
    const el = document.querySelector('.metafield-text');
    if (el) {
      el.textContent = packCount;
    }
  }

  const visualQuantity = document.querySelector('.product__block--visual_quantity');
  const isFinalSale = checked.dataset.isFinalSale === 'true';
  const overstockVariantId = checked.dataset.overstockVariantId;
  const overstockVariantPrice = Number(checked.dataset.overstockPrice || 0);
  const variantPrice = Number(checked.dataset.variantPrice || 0);
  const productFormVariantId = document.querySelector('.main-product-form .product-variant-id');

  console.log("Variant price", variantPrice);
  console.log("Overstock price", overstockVariantPrice);
  
  if (isFinalSale) {
    if (visualQuantity) {
      visualQuantity.style.display = 'none';
    }
    if (productFormVariantId && overstockVariantId) {
      productFormVariantId.value = overstockVariantId;
    }
  } else if (visualQuantity) {
    visualQuantity.style.display = 'block';
  }

  const shouldApplyOverstockPricing =
    isFinalSale && overstockVariantPrice && variantPrice && overstockVariantPrice !== variantPrice;

  if (shouldApplyOverstockPricing) {
    applyOverstockPricing(variantPrice, overstockVariantPrice);
  }
});
